import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-restrict-mobile',
  templateUrl: './restrict-mobile.component.html',
  styleUrls: ['./restrict-mobile.component.scss']
})
export class RestrictMobileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/restrict-mobile/restrict-mobile.component.ts